import React from 'react';

import { OrgPageAccessGate } from '@/components/OrgPageAccessGate';
import { useShouldShowAllTasks } from '@/hooks/useShouldShowAllTasks';

/**
 * Blocks direct URL access to All Tasks unless the sidebar would show it
 * (`useShouldShowAllTasks`: the org allowlist, then team leads or, with
 * `permissions_based_all_tasks_access` on, the permission map). Renders nothing
 * while the flag and checks load, or while the URL's org is not yet the selected
 * one (`OrgPageAccessGate`).
 */
export function AllTasksAccessGate({ children }: { children: React.ReactNode }) {
  return <OrgPageAccessGate {...useShouldShowAllTasks()}>{children}</OrgPageAccessGate>;
}
